
import React from "react";
import { Col, Row } from "react-bootstrap";

import macOs from "../../Assets/TechIcons/Apple MacOSX.svg";
import chrome from "../../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import intelliJ from "../../Assets/TechIcons/intellij-idea.svg";

function Toolstack() {
  const tools = [
    { name: "Parrot OS", image: null, label: "P" },
    { name: "Kali Linux", image: null, label: "K" },
    { name: "Wazuh", image: null, label: "SOC" },
    { name: "T-Pot", image: null, label: "TP" },
    { name: "VS Code", image: vsCode },
    { name: "Google Chrome", image: chrome },
    { name: "Git", image: null, label: "GIT" },
    { name: "IntelliJ IDEA", image: intelliJ },
    { name: "macOS", image: macOs },
    { name: "Terminal", image: null, label: "CLI" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map(({ name, image, label }) => (
        <Col
          xs={4}
          md={2}
          className="tech-icons"
          key={name}
          title={name}
        >
          {image ? (
            <img
              src={image}
              alt={name}
              className="tech-icon-images"
              style={{
                width: "45px",
                height: "45px",
                objectFit: "contain",
              }}
            />
          ) : (
            <div
              style={{
                width: "45px",
                height: "45px",
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "600",
                border: "1px solid currentColor",
                borderRadius: "10px",
              }}
            >
              {label}
            </div>
          )}

          <div className="tech-icons-text">{name}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
